// The newsletter form is injected as an iframe by a third-party script, so
// the title can't be set in the template. Label it as soon as it appears.
class IframeTitleHandler {
    constructor(selector = ".footer iframe", title = "Meld deg på nyhetsbrev") {
        const apply = () => {
            document.querySelectorAll(selector).forEach(frame => {
                if (!frame.title) frame.title = title
            })
        }

        apply()
        new MutationObserver(apply).observe(document.body, {childList: true, subtree: true})
    }
}

export default IframeTitleHandler
